import React, { useMemo } from 'react';
import { Empty } from 'antd';

const NoDataEmpty = (props) => {
    /**
     * @param props.distance
     * @param props.text
     * 距离和文案
     */
    return useMemo(() => (
        <Empty
            description={(
                <span style={{ color: '#999999' }}>
                    {props.text ? props.text : '暂无数据'}
                </span>
            )}
            image={require('./../assets/images/no_data_empty.png')}
            imageStyle={{
                height: 149
            }}
            style={{ padding: props.distance }} />
    ), []);
};

export default NoDataEmpty;